import { useCallback, useEffect } from "react";
import { useDebug } from "./debug";

export function SecretControls() {
	const { toggleDebug } = useDebug();

	const onKeyDown = useCallback(
		async (event: KeyboardEvent) => {
			const inputs = ["input", "textarea"];
			const tagName =
				event.target instanceof HTMLElement ? event.target.tagName.toLowerCase() : undefined;
			const notFormElement = (tagName && !inputs.includes(tagName)) || !tagName;

			if (notFormElement) {
				if (event.shiftKey && event.key === "X") {
					toggleDebug();
				}
			}
		},
		[toggleDebug],
	);

	useEffect(() => {
		window.addEventListener("keydown", onKeyDown);

		return () => {
			window.removeEventListener("keydown", onKeyDown);
		};
	}, [onKeyDown]);

	return null;
}
